import { gql } from "@apollo/client";

export const EmailLookupMutation = gql`
  mutation EmailLookup($email: String!, $origin: String) {
    emailLookup(email: $email, origin: $origin) {
      email
      username
      method
      methodURL
      region
    }
  }
`;
